import { Link } from "react-router-dom";
import { Field } from "@/components/ax/Field";
import { RadioChips } from "@/components/ax/RadioChips";
import { useI18n } from "@/i18n";

export const StepQuestion = ({ s }) => {
  const { t } = useI18n();
  const set = (k) => (e) => {
    s.setForm((f) => ({ ...f, [k]: e.target.value }));
    s.setErrors((x) => ({ ...x, [k]: undefined }));
  };
  return (
    <div data-testid="intake-step-1" className="enter mt-8 flex flex-col gap-4">
      <Field
        label={t("field.title")}
        maxLength={80}
        value={s.form.title}
        onChange={set("title")}
        error={s.errors.title}
        testId="intake-title-input"
        autoFocus
      />
      <Field
        multiline
        label={t("field.question")}
        maxLength={400}
        value={s.form.question}
        onChange={set("question")}
        error={s.errors.question}
        hint={t("question.hint")}
        testId="intake-question-input"
      />
      <Field
        multiline
        label={t("field.outcome")}
        maxLength={200}
        value={s.form.desiredOutcome}
        onChange={set("desiredOutcome")}
        testId="intake-outcome-input"
      />
      <RadioChips
        legend={t("field.horizon")}
        name="horizon"
        testId="intake-horizon"
        value={s.form.horizonDays}
        onChange={(v) => s.setForm((f) => ({ ...f, horizonDays: v }))}
        options={[30, 90, 180].map((n) => ({ value: n, label: t("horizon.days", { n }), mono: true }))}
      />
      <p className="m-0 text-sm leading-5 text-ax-muted">{t("intake.horizonHint")}</p>
      <Field
        type="date"
        label={t("chooseBy.label")}
        value={s.form.chooseBy}
        onChange={set("chooseBy")}
        hint={s.form.chooseBy ? t("chooseBy.wib") : t("chooseBy.empty")}
        disabled={!!s.busy || ["committed", "deferred"].includes(s.decision?.status)}
        testId="intake-choose-by-input"
      />
      <Link
        to="/keputusan/contoh"
        data-testid="intake-example-link"
        className="inline-flex min-h-[48px] items-center text-sm font-medium text-ax-link hover:underline"
      >
        {t("intake.example")}
      </Link>
    </div>
  );
};
